import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import '/client/app/styles/text.scss';
import CreateAccountFormContainer from '../../components/forms/createAccountForm/createAccountFormContainer';
import './createAccount.scss';

export default function CreateAccountView(props) {
	const { location } = props;
	const { dest } = queryString.parse(location.search);
	return (
		<div>
			<div className="mainTitle">create account</div>
			<div className="createAccountMain">
				<CreateAccountFormContainer destination={dest} />
			</div>
		</div>
	);
}

CreateAccountView.propTypes = {
	location: PropTypes.shape({
		search: PropTypes.string,
	}).isRequired,
};
